"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthProviderTypes = void 0;
var AuthProviderTypes;
(function (AuthProviderTypes) {
    AuthProviderTypes["Capital"] = "capital";
})(AuthProviderTypes = exports.AuthProviderTypes || (exports.AuthProviderTypes = {}));
//# sourceMappingURL=AuthProvider.js.map